module.exports = __webpack_public_path__ + "img/leftSlope.4b382f90.png";